import { RestClient } from '@/api/rest-client'
import { GamificationScore } from '@/api/model/gamification-score.ts'

export class GamificationScoreClient extends RestClient<GamificationScore> {
    collectionName = 'gamification_scores'
    parseData = GamificationScore.fromData
}
